import { createSlice } from "@reduxjs/toolkit";
import { QueryParams } from "@router/route-params";
import { getBooleanQueryParam } from "@utils/url-utils";

/**
 * State of the current App
 */

export const initialState = {
  /** Beta testing is enabled in non-production environments or if the user has enabled with queryParam. */
  isBetaTestingEnabled: false,
  /** Alpha testing is enabled if the user has enabled with queryParam. */
  isAlphaTestingEnabled: false,
  /**
   * Dev mode is enabled if the user has enabled it with queryParam.
   * Initialize to avoid that it's false during page load, and that SecuredRoute forwards to error page too early.
   * Value gets then set by QueryParamsLoader (verifying if it's indeed an internal user).
   */
  isDevModeEnabled: getBooleanQueryParam(globalThis.location.search, QueryParams.enableDev)
};

/**
 * Slice to access state of general app meta data
 */
const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setIsBetaTestingEnabled(state, action) {
      state.isBetaTestingEnabled = action.payload;
    },
    setIsAlphaTestingEnabled(state, action) {
      state.isAlphaTestingEnabled = action.payload;
    },
    setIsDevModeEnabled(state, action) {
      state.isDevModeEnabled = action.payload;
    },
    resetAppState: () => initialState
  }
});
export const {
  setIsBetaTestingEnabled,
  setIsAlphaTestingEnabled,
  setIsDevModeEnabled,
  resetAppState
} = appSlice.actions;
export const appReducer = appSlice.reducer;